import React from 'react'
import PropTypes from 'prop-types'
import { useDispatch } from 'react-redux'
import Typography from '@mui/material/Typography'
import ModalContainer from '../ModalContainer'
import { hideModal, lockOutUser } from '../../../redux/actions'

export function LockOutUserModal({ user }) {
  const dispatch = useDispatch()

  const onCancel = () => dispatch(hideModal())
  const onConfirm = () => {
    dispatch(lockOutUser(user.id))
      .then(dispatch(hideModal()))
  }

  return (
    <ModalContainer
      title="Lock Out User"
      modal
      maxWidth="xs"
      fullWidth="true"
      actions={{
        primaryAction: {
          label: 'Confirm',
          onClick: () => onConfirm(user),
        },
        secondaryAction: {
          label: 'Cancel',
          onClick: onCancel,
        },
      }}
    >
      <Typography style={{ marginTop: '10px' }}>
        Are you sure you want to lock this user out?
      </Typography>
      <Typography style={{ marginTop: '10px' }}>
        The user will no longer be able to log in with their GovX
        credentials.
      </Typography>
    </ModalContainer>
  )
}

LockOutUserModal.propTypes = {
  user: PropTypes.shape({
    id: PropTypes.string.isRequired,
  }).isRequired,
}

export default LockOutUserModal
